import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@material-ui/core';
import useStyles from './Loader.styles';

const loaderGifs = {
  default: require('../../assets/loader/loader.gif').default,
  ABI: require('../../assets/loader/BeltlineLoading.gif').default,
};

// HashRouter puts the route path after '#'; the company slug is always its first segment.
const getCompanyFromUrl = () => window.location.hash.replace(/^#\/?/, '').split('/')[0];

const Loader = ({ txt = null }) => {
  const classes = useStyles();
  const loaderGif =
    sessionStorage.getItem('isABI') === 'true' || getCompanyFromUrl() === 'abi'
      ? loaderGifs.ABI
      : loaderGifs.default;
  return (
    <Modal open BackdropProps={{ style: { backgroundColor: 'rgba(255,255,255,0.9)' } }}>
      <div className={classes.loaderouter}>
        <img style={{ height: '50px', width: '50px' }} src={loaderGif} alt="Loader" />
        <span>{txt || 'Loading...'}</span>
      </div>
    </Modal>
  );
};

Loader.propTypes = {
  txt: PropTypes.string.isRequired,
};

export default Loader;
